import { ObjectKinds } from ".";
import { IHisInfoItemBehavior } from "./items/IHisInfoItemBehavior";
import { DefaultDateBehavior } from "./items/DefaultDateBehavior";
import { DefaultTimeBehavior } from "./items/DefaultTimeBehavior";
import { DefaultDateTimeBehavior } from "./items/DefaultDateTimeBehavior";
import { DefaultTextBehavior } from "./items/DefaultTextBehavior";
import { PtNameSeiBehavior } from "./items/PtNameSeiBehavior";
import { PtNameMeiBehavior } from "./items/PtNameMeiBehavior";
import { PtKanaSeiBehavior } from "./items/PtKanaSeiBehavior";
import { PtKanaMeiBehavior } from "./items/PtKanaMeiBehavior";
import { PtKanaHiraganaBehavior } from "./items/PtKanaHiraganaBehavior";
import { PtNameBehavior } from "./items/PtNameBehavior";
import { PtKanaBehavior } from "./items/PtKanaBehavior";
import { PtKanaHiraganaMeiBehavior } from "./items/PtKanaHiraganaMeiBehavior";
import { PtKanaHiraganaSeiBehavior } from "./items/PtKanaHiraganaSeiBehavior";
import { PtAgeBehavior } from "./items/PtAgeBehavior";
import { PtMonthAgeBehavior } from "./items/PtMonthAgeBehavior";
import { PtBldPressureBehavior } from "./items/PtBldPressureBehavior";
import { EnterHospDateBehavior } from "./items/EnterHospDateBehavior";
import { LeaveHospDateBehavior } from "./items/LeaveHospDateBehavior";
import { OpePeriodBehavior } from "./items/OpePeriodBehavior";
import { DefaultCreateDateBehavior } from "./items/DefaultCreateDateBehavior";
import { FilledCreateDateBehavior } from "./items/FilledCreateDateBehavior";
import { EnterHospPeriodBehavior } from "./items/EnterHospPeriodBehavior";

export class HisItemBehaviorFactory {
  /** 特殊な生成・変換を行うHIS項目とその処理の対応表 */
  // TODO: v1の生成変換処理から探し追加する
  private static _createOrConvertItemDictionary: {[key: string]: (defaultDateFormat?: string) => IHisInfoItemBehavior } = {
    CREATE_DATE: (defaultDateFormat?: string) => new DefaultCreateDateBehavior("CREATE_DATE", defaultDateFormat),
    CREATE_USER: undefined,
    DOCTOR: undefined,
    ENTER_HOSP_DATE: (defaultDateFormat?: string) => new EnterHospDateBehavior(defaultDateFormat),
    ENTER_HOSP_PERIOD: () => new EnterHospPeriodBehavior(),
    LAST_UPDATE_DATE: (defaultDateFormat?: string) => new FilledCreateDateBehavior("LAST_UPDATE_DATE", defaultDateFormat),
    LAST_UPDATE_USER: undefined,
    LEAVE_HOSP_DATE: (defaultDateFormat?: string) => new LeaveHospDateBehavior(defaultDateFormat),
    OPE_PERIOD: () => new OpePeriodBehavior(),
    PAGE_NUMBER: undefined,
    PT_AGE: () => new PtAgeBehavior(),
    PT_BLD_PRESSURE: () => new PtBldPressureBehavior(),
    PT_KANA: () => new PtKanaBehavior(),
    PT_KANA_HIRAGANA: () => new PtKanaHiraganaBehavior(),
    PT_KANA_HIRAGANA_MEI: () => new PtKanaHiraganaMeiBehavior(),
    PT_KANA_HIRAGANA_SEI: () => new PtKanaHiraganaSeiBehavior(),
    PT_KANA_MEI: () => new PtKanaMeiBehavior(),
    PT_KANA_SEI: () => new PtKanaSeiBehavior(),
    PT_NAME: () => new PtNameBehavior(),
    PT_NAME_MEI: () => new PtNameMeiBehavior(),
    PT_NAME_SEI: () => new PtNameSeiBehavior(),
    PT_MONTH_AGE: () => new PtMonthAgeBehavior(),
    USER_ACCOUNT: undefined,
    HOST_NAME: undefined,
  };

  /**
   * 選択画面で表示されるHIS項目（病名・入院・手術情報）のデータ型とHIS情報のkeyの対応。
   * 選択画面で表示される項目はデータ型の情報を持っていないため
   * データ型ごとにHIS情報のkeyをまとめている。
   */
  // TODO: バックエンド側でマスタとして持てないか？ HisInformationItemにデータ型を持たせる？
  private static _hisInfoKeysInScreen = {
    date: [
      "DISEASE_DEVELOPMENT_DATE",
      "DISEASE_EFFECTIVE_DATE",
      "DISEASE_START_DATE",
      "DISEASE_TRANSFER_DATE",
      "OPE_START_DATE",
      "OPE_END_DATE",
    ],
    time: [
      "OPE_END_TIME",
      "OPE_NECESSARY_TIME",
      "OPE_START_TIME",
    ],
    dateTime: [
      "ENTER_HOSP_DATE_TIME",
      "LEAVE_HOSP_DATE_TIME",
    ]
  };

  public static create(key: string, defaultDateFormat?: string, objectKind: ObjectKinds = ObjectKinds.Text): IHisInfoItemBehavior {
    const creater = this._createOrConvertItemDictionary[key];
    // 厳密比較ではないので、nullもしくはundefinedではないとき分岐する
    if (creater != null) { return creater(defaultDateFormat); } // 特殊な生成・変換を優先して返す

    if (this.isDateType(key, objectKind)) { return new DefaultDateBehavior(key, defaultDateFormat); }
    if (this.isTimeType(key, objectKind)) { return new DefaultTimeBehavior(key); }
    if (this.isDateTimeType(key, objectKind)) { return new DefaultDateTimeBehavior(key, defaultDateFormat); }

    return new DefaultTextBehavior(key);
  }

  private static isDateType(key: string, objectKind: ObjectKinds) {
    return (objectKind === ObjectKinds.Date)
      || (this._hisInfoKeysInScreen.date.indexOf(key) >= 0);
  }

  private static isTimeType(key: string, objectKind: ObjectKinds) {
    return (objectKind === ObjectKinds.Time)
      || (this._hisInfoKeysInScreen.time.indexOf(key) >= 0);
  }

  private static isDateTimeType(key: string, objectKind: ObjectKinds) {
    return (this._hisInfoKeysInScreen.dateTime.indexOf(key) >= 0);
  }
}
